{
  "WALLBOARD": {
    "LOADING": "Načítavanie telefonních front...",
    "NO_QUEUES": "Neboli nájdené žiadne telefónne fronty.",
    "AGENTS": "Agenti",
    "NO_AGENTS": "Žádní online agenti v tejto fronte.",
    "NO_AGENTS_ONLINE": "Žádní online agenti.",
    "WAITING_CALLERS": "Čekající volající",
    "NO_CALLERS": "Žádní čekající volající.",
    "UNKNOWN_CALLER": "Neznámý volající",
    "POSITION": "Pozice",
    "STATUS": "Stav",
    "TIME": "Čas",
    "AGENT": "Agent",
    "EXTENSION": "Linka",
    "AVAILABLE": "Dostupní",
    "READY": "Pripravenie agenti",
    "ON_CALL": "Agenti na hovoru",
    "QUEUE_CALL": "Volající agenti",
    "OTHER_CALL": "Iný hovor",
    "PAUSED": "Agenti na pauze",
    "WAITING": "Čekající hovory",
    "MISSED_CALLS": "Zmeškané hovory",
    "HANDLED_CALLS": "Odbavené prichádzajúci hovory",
    "OUTBOUND_CALLS": "Odbavené odchádzajúci hovory",
    "AVAILABILITY": "Dostupnost",
    "AVAILABILITY_TOOLTIP": "Procento príchozích hovorô zvednutých agenty (hovory, ktoré sa podarilo zvednout, nespadly do zmeškaných)",
    "TOTAL": "celkom",
    "AGENTS_COUNT": "{onCall} volají / {total} celkom",
    "NO_AVAILABLE": "nikto online",
    "WAITING_CALLERS_COUNT": "{count} čekají",
    "CALLER": "Volající",
    "NUMBER": "Číslo",
    "WAIT_TIME": "Doba čakanie",
    "QUEUES": "Fronty",
    "ACTION": "Akcia",
    "PICKUP_CALL": "Zvednout",
    "PICKING_UP": "Prepájam...",
    "PICKUP_SUCCESS": "Požadavek na zvednutie hovoru bol úspešne odoslaný.",
    "PICKUP_ERROR": "Nepodarilo sa zvednout hovor. Zkuste to prosím znovu.",
    "PICKUP_DISABLED_TOOLTIP": "Hovor nemožno zvednout, ak máte probíhající hovor alebo ste offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Bez prístupu"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Bez prístupu"
    }
  }
}
